import { NW_TAXES } from '../paths';

export default {
  text: {
    auth: 'File your taxes for a flat fee of $50, no matter your situation. No hidden costs, no hassle.',
    unauth:
      'File your taxes for a flat fee of $50, no matter your situation. No hidden costs, no hassle.',
  },
  ctaText: 'Learn more',
  ctaLink: NW_TAXES,
  campaign: 'NW_TAXES',
  campaignKey: 'taxes_ribbon',
};
